var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "560", scrollable: "" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "dialog-change-log-card" },
        [
          _c(
            "v-card-title",
            { staticClass: "navy darken-1 white--text" },
            [
              _vm._v("\n      Novità Asta Live\n      "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "white--text",
                  attrs: { depressed: "", light: "", icon: "" },
                  on: { click: _vm.dismiss },
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "change-log-content pa-4" },
            [
              _c(
                "v-timeline",
                {
                  staticClass: "change-log-timeline",
                  attrs: { dense: "", clipped: "" },
                },
                _vm._l(_vm.visibleEvents, function (event) {
                  return _c(
                    "v-timeline-item",
                    {
                      key: event.date + "-" + event.title,
                      attrs: { color: "secondary", small: "" },
                    },
                    [
                      _c("div", { staticClass: "change-log-date" }, [
                        _vm._v(_vm._s(event.date)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "change-log-title" }, [
                        _vm._v(_vm._s(event.title)),
                      ]),
                      _vm._v(" "),
                      event.description
                        ? _c("div", {
                            staticClass: "change-log-description",
                            domProps: { innerHTML: _vm._s(event.description) },
                          })
                        : _vm._e(),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }